<template>
  <div>
    <ul
      id="autocomplete-results"
      v-show="isOpen"
      ref="scrollContainer"
      class="autocomplete-results"
      v-if="
        this.searchMatch.length != 0 && this.checkMatchInput != this.searchMatch
      "
    >
      <li
        ref="options"
        v-for="(result, i) in searchMatch"
        :key="i"
        @click="selectItem(i), chooseItem()"
        class="autocomplete-result"
        :class="{ 'is-active': i === arrowCounter }"
      >
        <text-highlight :queries="handleQuery()">${{ result }}</text-highlight>
      </li>
    </ul>
  </div>
</template>

<script>
import _ from 'lodash'
import TextHighlight from 'vue-text-highlight'
import apiKeyValueExplorer from '@/apis/key_value_explorer'

export default {
  props: {
    input: String,
    start: Number,
    drawFlowItems: Object,
    typeComponent: String,
    currentIndex: Number,
    apiForIntellisense: Object,
    enterIntellisense: Number,
    eventKey: String,
    property: String,
    functionName: String
  },
  components: {
    TextHighlight
  },
  data() {
    return {
      searchMatch: [],
      selectedIndex: 0,
      clickedChooseItem: false,
      wordIndex: 0,
      flowBuilderVariables: [
        '{system.direction}',
        '{system.loop.current}',
        '{system.loop.index}',
        '{system.loop.length}',
        '{system.loop.order}',
        '{system.phone_number}',
        '{system.payload.<object>}',
        '{system.sip_header_caller_id}',
        '{system.session_no}',
        '{system.tvo_asr_token}',
        '{system.status}'
      ],
      outboundCampaignVariables: [
        '{system.phone_number}',
        '{system.payload.<object>}'
      ],
      isOpen: false,
      arrowCounter: -1,
      checkCurrentWord: '',
      checkMatchInput: ''
    }
  },
  computed: {
    listToSearch() {
      if (
        typeof this.flowBuilderVariables !== 'undefined' &&
        this.flowBuilderVariables.length > 0
      ) {
        return this.flowBuilderVariables
      } else {
        return this.flowBuilderVariables
      }
    },
    currentWord() {
      return this.input.replace(/(\r\n|\n|\r)/gm, ' ').split('$')[
        this.wordIndex
      ]
    },
    inputSplitted() {
      return this.input.replace(/(\r\n|\n|\r)/gm, ' ').split('$')
    }
  },
  watch: {
    input: {
      deep: true,
      handler(val) {
        this.inputValue(val)
      }
    },
    start: {
      handler(val) {
        // if (val > -1) {
        //   const aList = document.querySelectorAll('.autocomplete-results')
        //   if (val < this.searchMatch.length) {
        //     //ใช้ ดัก error (reading 'classList')
        //     if (aList.length > 0) {
        //       for (const li of aList) {
        //         li.classList.remove('is-active')
        //       }
        //       aList[val].classList.add('is-active')
        //     }
        //   }
        // }
        // -----ใช้เช็คว่า user กด Event อะไีรอยู่
        if (this.searchMatch.length > 0) {
          if (this.eventKey == 'enter') {
            this.setWord(this.searchMatch[this.arrowCounter])
            this.arrowCounter = -1
          } else if (this.eventKey == 'keydown') {
            if (this.arrowCounter < this.searchMatch.length - 1) {
              this.arrowCounter = this.arrowCounter + 1
              this.fixScrolling()
            }
          } else if (this.eventKey == 'keyup') {
            if (this.arrowCounter > 0) {
              this.arrowCounter = this.arrowCounter - 1
              this.fixScrolling()
            }
          }
        }
      }
    }
  },

  created() {
    this.initial()
  },
  methods: {
    async initial() {
      // await this.getInputName()
      // await this.getApiName()
      // await this.pushApiToIntellisense()
      // if (this.drawFlowItems.Home.data[1].data.platform == 'voice') {
      //   await this.getInputName()
      // } else if (this.drawFlowItems.Home.data[1].data.platform == 'chat') {
      // }
      // await this.getApiName()
      // await this.pushApiToIntellisense()
      this.getComponentName()
      this.initialIntellisenseList()
    },
    async initialIntellisenseList() {
      await this.pushApiToIntellisense()
      await this.getKeyValueForIntellisense()
      this.flowBuilderVariables = _.sortBy(this.flowBuilderVariables)
    },
    async pushApiToIntellisense() {
      try {
        //======== add field ทั้งหมดเข้า array =====
        if (
          this.functionName == 'preCallApi' ||
          this.functionName == 'postCallApi'
        ) {
          this.flowBuilderVariables = this.outboundCampaignVariables
        } else {
          this.flowBuilderVariables.push(
            ...this.apiForIntellisense.flowBuilderVariables
          )
        }
        //======== add field ทั้งหมดเข้า array =====
      } catch {}
    },
    async getKeyValueForIntellisense() {
      try {
        const getKeyValueExplorer = await apiKeyValueExplorer.getKeyValueExplorerList()

        if ((getKeyValueExplorer || {}).data) {
          getKeyValueExplorer.data.forEach(item =>
            this.flowBuilderVariables.push(
              '{system.keyValue.' + `${item.key}` + '}'
            )
          )
        }
      } catch {}
    },
    getComponentName() {
      try {
        //======== get name Compronent ทั้งหมด แล้ว push ใส่ array ====
        const inputArray = []
        const layer1 = this.drawFlowItems
        for (const item in layer1) {
          const layer2 = layer1[item]

          for (const item in layer2) {
            const layer3 = layer2[item]

            for (const item in layer3) {
              if (
                ['input', 'api', 'code', 'gen_ai'].includes(
                  layer3[item].data.node
                )
              ) {
                inputArray.push({
                  node: layer3[item].data.node,
                  name: layer3[item].data.name
                })
              }
            }
          }
        }
        //========end  get name Compronent ทั้งหมด แล้ว push ใส่ array ====

        //======= get ค่า entity จาก nlu เพื่อนำไปต่อใน input เพื่อได้ key ที่สมบูรณ์
        // const getTestNlu = await apiNlu.getNluEntity()

        for (let i = 0; i < inputArray.length; i++) {
          if (inputArray[i].node === 'input') {
            //ค่า Intellisense สำหรับ component input
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.confidence}'
            )
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.entity.<entity>}'
            )
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.entity.custom.<entity>.0}'
            )
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.entity.custom.<entity>.0.reference}'
            )
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.entity.custom.<entity>.0.synonym}'
            )
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.intent}'
            )
            this.flowBuilderVariables.push('{' + inputArray[i].name + '.label}')
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.input.text}'
            )
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.utterance}'
            )
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.asrInfo.gender}'
            )
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.asrInfo.unclear}'
            )
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.asrInfo.noisy}'
            )
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.asrInfo.quiet}'
            )
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.asrInfo.clipping}'
            )
          } else if (inputArray[i].node === 'api') {
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.data.<object>}'
            )
            //---------- ${<api>.status}
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.' + 'status}'
            )
            //---------- ${<api>.statusText}
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.' + 'statusText}'
            )
          } else if (inputArray[i].node === 'code') {
            this.flowBuilderVariables.push('{' + inputArray[i].name + '.data}')
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.' + 'error}'
            )
          } else if (inputArray[i].node === 'gen_ai') {
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.status}'
            )
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.statusText}'
            )
            this.flowBuilderVariables.push('{' + inputArray[i].name + '.text}')
            this.flowBuilderVariables.push(
              '{' + inputArray[i].name + '.data.<object>}'
            )
          }
        }
        //=======end get ค่า entity จาก nlu เพื่อนำไปต่อใน input เพื่อได้ key ที่สมบูรณ์
      } catch {}
    },
    // async getInputName() {
    //   try {
    //     //======== get name Compronent type input ทั้งหมด แล้ว push ใส่ array ====
    //     const inputArray = []
    //     const layer1 = this.drawFlowItems
    //     for (const item in layer1) {
    //       const layer2 = layer1[item]

    //       for (const item in layer2) {
    //         const layer3 = layer2[item]

    //         for (const item in layer3) {
    //           if (layer3[item].data.node === 'input') {
    //             inputArray.push(layer3[item].data.name)
    //           }
    //         }
    //       }
    //     }
    //     //========end  get name Compronent type input ทั้งหมด แล้ว push ใส่ array ====
    //     //======= get ค่า entity จาก nlu เพื่อนำไปต่อใน input เพื่อได้ key ที่สมบูรณ์
    //     // const getTestNlu = await apiNlu.getNluEntity()

    //     for (let i = 0; i < inputArray.length; i++) {
    //       for (const property in this.apiForIntellisense.nluEntity) {
    //         this.flowBuilderVariables.push(
    //           '{' + inputArray[i] + '.' + 'entity.' + `${property}` + '}'
    //         )
    //       }
    //     }
    //     //=======end get ค่า entity จาก nlu เพื่อนำไปต่อใน input เพื่อได้ key ที่สมบูรณ์
    //     //-------------- utterance-------------
    //     for (let i = 0; i < inputArray.length; i++) {
    //       this.flowBuilderVariables.push('{' + inputArray[i] + '.utterance}')
    //       this.flowBuilderVariables.push('{' + inputArray[i] + '.intent}')
    //       this.flowBuilderVariables.push('{' + inputArray[i] + '.<nlu-data>}')
    //       this.flowBuilderVariables.push('{' + inputArray[i] + '.nluResult}')
    //       this.flowBuilderVariables.push('{' + inputArray[i] + '.confidence}')
    //       this.flowBuilderVariables.push('{' + inputArray[i] + '.is_english}')
    //       this.flowBuilderVariables.push('{' + inputArray[i] + '.is_confirm}')
    //       this.flowBuilderVariables.push('{' + inputArray[i] + '.in_domain}')
    //     }
    //   } catch {}
    // },
    // async getApiName() {
    //   try {
    //     const inputArray = []
    //     const layer1 = this.drawFlowItems
    //     for (const item in layer1) {
    //       const layer2 = layer1[item]

    //       for (const item in layer2) {
    //         const layer3 = layer2[item]

    //         for (const item in layer3) {
    //           if (layer3[item].data.node === 'api') {
    //             inputArray.push(layer3[item].data.name)
    //           }
    //         }
    //       }
    //     }

    //     for (let i = 0; i < inputArray.length; i++) {
    //       //---------- ${<api>.data.<object>}
    //       this.flowBuilderVariables.push(
    //         '{' + inputArray[i] + '.data.<object>}'
    //       )
    //       //---------- ${<api>.status}
    //       this.flowBuilderVariables.push('{' + inputArray[i] + '.' + 'status}')
    //       //---------- ${<api>.statusText}
    //       this.flowBuilderVariables.push(
    //         '{' + inputArray[i] + '.' + 'statusText}'
    //       )
    //     }
    //   } catch {}
    // },
    setWord(word) {
      let currentWords = this.input
        .replace(/(\r\n|\n|\r)/gm, '__br__ ')
        .split('$')
      currentWords[this.wordIndex] = currentWords[this.wordIndex].replace(
        this.currentWord,
        word + ''
      )
      this.wordIndex += 1
      let resultSetWord = currentWords.join('$').replace(/__br__\s/g, '\n')
      this.updateInputFromIntellisense(resultSetWord)
    },
    selectItem(index) {
      this.selectedIndex = index
      this.chooseItem()
    },
    chooseItem(e) {
      this.clickedChooseItem = true
      if (this.selectedIndex !== -1 && this.searchMatch.length > 0) {
        if (e) {
          e.preventDefault()
        }

        this.setWord(this.searchMatch[this.selectedIndex])
        // for Write
        this.updateIntellisense(this.searchMatch[this.selectedIndex])

        // for Write
        this.selectedIndex = -1
        this.isOpen = false
      }
    },

    focus(val) {
      this.searchMatch = []
      //เพิ่ม this.currentWord !== undefined) มาเพื่อแก้ error toLowerCase undefined
      if (
        this.currentWord !== '' &&
        this.currentWord !== undefined &&
        this.inputSplitted.length > 1
      ) {
        // this.inputSplitted.length > 1 ใช้แก้ปัญหาการพิมพ์ครั้งแรก ไม่พิมพ์$ แต่ก็ยัง show intellisense
        if (this.currentWord !== '{' && this.currentWord !== '}') {
          //สร้่างมาเพื่อเก็บค่าที่พิมพ์ก่อนหน้า
          const previousCurrentWord = this.checkCurrentWord
          this.searchMatch = this.listToSearch.filter(
            el => el.toLowerCase().indexOf(this.currentWord.toLowerCase()) >= 0
          )
          // ค่าที่มีการแก้
          this.checkCurrentWord = this.currentWord
          if (previousCurrentWord != this.checkCurrentWord) {
            //ใช้เช็คว่ามีการพิมพ์คำใหม่หรือไหม
            //เช็คว่าค่าก่อนหน้าและหลังเปลี่ยนไหม ถ้าเป็นให้set arrowCounter = -1
            this.arrowCounter = -1
          }
          this.$emit('clearSelected')
        }
      }
    },
    inputValue(val) {
      this.focus(val)
      // ใช้เช็คว่าคำที่พิมพ์มา match กับ ที่filter เจอไหม ถ้าMatch จะไม่ Show
      let replaceVal = val.replace(/(\r\n|\n|\r)/gm, ' ').split('$')[
        this.wordIndex
      ]
      this.checkMatchInput = replaceVal
      // ใช้เช็คว่าคำที่พิมพ์มา match กับ ที่filter เจอไหม ถ้าMatch จะไม่ Show
      this.isOpen = true
      this.selectedIndex = 0
      // จุดที่ทำให้พิมพ์ได้เยอะๆ หลายๆคำ
      this.wordIndex = this.inputSplitted.length - 1
      // this.inputSplitted.length คือ จำนวนคำที่เรา intellisense ไปแล้ว
    },

    updateIntellisense(data) {
      //==== for Write
      // data = '$' + data
      this.$emit('updateIntellisense', data)
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight
      this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter
    },
    handleQuery() {
      if (this.currentWord) return this.currentWord.split(' ')
      return []
    },
    updateInputFromIntellisense(data) {
      //==== for Write
      // data = '$' + data
      this.$emit('updateInputFromIntellisense', this.property, data)
    }
  }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
} */

.autocomplete {
  position: relative;
  width: 130px;
}

.autocomplete-results {
  padding: 0;
  margin: 0;
  padding-left: 0px !important;
  border: 1px solid #eeeeee;
  /* height: 120px; */
  max-height: 150px;
  overflow: auto;
  width: 100%;
  background-color: white;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 10px 10px;
  cursor: pointer;
  color: black;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #f7f7f7;
  color: black;
}
</style>
